import { __assign } from "tslib";
import React from 'react';
var NativeOptGroup = React.forwardRef(function (props, ref) {
    return (React.createElement("optgroup", __assign({ ref: ref }, props), props.children));
});
NativeOptGroup.displayName = 'NativeSelectOptGroup';
export default NativeOptGroup;
//# sourceMappingURL=native-opt-group.js.map